module.exports = __webpack_public_path__ + "img/1581605494.250ed81d.jpg";